import { initMediaProtection } from '../src/media_protection'

document.addEventListener('DOMContentLoaded', function () {
  initMediaProtection({
    rootSelector: '.wrap',
    targetSelector: 'img, video',
    disableSaveShortcut: true,
  })
})
